import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Avatar, Card, CardHeader } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { TagsKanbanContainer } from "../TagsKanbanContainer";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		background: theme.palette.tabHeaderBackground,
		flex: "none",
		borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
		height: "65px"
	},
}));

const TicketHeaderSkeleton = () => {
	const classes = useStyles();

	try {
		return (
			<Card square className={classes.ticketHeader}>
				<CardHeader
					titleTypographyProps={{ noWrap: true }}
					subheaderTypographyProps={{ noWrap: true }}
					avatar={
						<Skeleton animation="wave" variant="circle">
							<Avatar alt="contact_image" />
						</Skeleton>
					}
					title={<Skeleton animation="wave" width={80} />}
					subheader={<Skeleton animation="wave" width={140} />}
				/>
				<TagsKanbanContainer />
			</Card>
		);
	} catch (error) {
		console.error("Erro ao renderizar o TagsKanbanContainer:", error);
		return <div>Erro ao carregar o conteúdo.</div>;
	}
};

export default TicketHeaderSkeleton;
